import { render, staticRenderFns } from "./PriceRangeSettings.vue?vue&type=template&id=61381485&scoped=true&"
import script from "./PriceRangeSettings.vue?vue&type=script&lang=js&"
export * from "./PriceRangeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61381485",
  null
  
)

export default component.exports